import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { userService } from '../services/userService';

import Loader from './Loader';

interface AuthorisedApp {
  id: number;
  name: string;
  scopes: string[];
  colour?: string;
  last_used?: string;
}

const AuthorisedAppsPanel = () => {
  const { user } = useAuth();
  const [apps, setApps] = useState<AuthorisedApp[]>([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    userService
      .getAuthorisedApps(page, 5)
      .then((response) => {
        setApps(response.data.apps as AuthorisedApp[]);
        setPages(response.data.pages);
      })
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to fetch authorised apps'))
      .finally(() => setLoading(false));
  }, [user, page]);

  return (
    <div className="card">
      <h3>Authorised apps</h3>
      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <Loader />
        </div>
      )}
      {error && <p style={{ color: 'var(--danger)' }}>{error}</p>}
      {!loading && !error && apps.length === 0 && <p>No authorised apps yet.</p>}
      {!loading && !error && apps.length > 0 && (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
          {apps.map((app) => (
            <li key={app.id} style={{ border: '1px solid var(--border)', padding: '0.9rem 1rem', borderRadius: '14px' }}>
              <strong>{app.name}</strong>
              <p style={{ margin: '0.2rem 0', color: 'var(--gray)' }}>{app.scopes?.join(', ') || 'No scopes reported'}</p>
              {app.last_used && (
                <p style={{ margin: 0, color: 'var(--gray)', fontSize: '0.85rem' }}>Last used: {app.last_used}</p>
              )}
            </li>
          ))}
        </ul>
      )}
      {pages > 1 && (
        <div style={{ display: 'flex', gap: '0.8rem', marginTop: '1rem' }}>
          <button disabled={page === 1} onClick={() => setPage((prev) => Math.max(1, prev - 1))}>
            Previous
          </button>
          <span>
            Page {page} / {pages}
          </span>
          <button disabled={page === pages} onClick={() => setPage((prev) => Math.min(pages, prev + 1))}>
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default AuthorisedAppsPanel;
